import { render, staticRenderFns } from "./AccountantsMenu.vue?vue&type=template&id=3365a9c4&scoped=true&"
import script from "./AccountantsMenu.vue?vue&type=script&lang=js&"
export * from "./AccountantsMenu.vue?vue&type=script&lang=js&"
import style0 from "./AccountantsMenu.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AccountantsMenu.vue?vue&type=style&index=1&id=3365a9c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3365a9c4",
  null
  
)

export default component.exports